module.exports = __webpack_public_path__ + "img/jilu.44249902.png";